var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-card", { staticClass: "custom-card" }, [
        _c(
          "div",
          { staticClass: "d-flex align-items-center w-100" },
          [
            _c("h5", {}, [_vm._v("Документы")]),
            _vm._v(" "),
            _c(
              "b-button",
              {
                staticClass: "custom-btn-primary ml-auto",
                attrs: { disabled: _vm.isDisabled },
                on: { click: _vm.onAdd }
              },
              [
                _c("v-icon", { attrs: { name: "buttons/plus", size: 12 } }),
                _vm._v("\n        Добавить\n      ")
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "page-body" },
          [
            _vm.isBusy || (_vm.items && _vm.items.length > 0)
              ? [
                  _c(
                    "div",
                    { staticClass: "page-table-container" },
                    [
                      _c("b-table", {
                        ref: "task_files",
                        staticClass: "custom-table mb-0",
                        attrs: {
                          id: "task-files",
                          selectable: "",
                          "select-mode": "single",
                          responsive: "",
                          busy: _vm.isBusy,
                          items: _vm.items,
                          fields: _vm.fields,
                          "no-provider-filtering": "",
                          "no-provider-paging": "",
                          "no-provider-sorting": ""
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "table-busy",
                              fn: function() {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "text-center text-success my-2"
                                    },
                                    [
                                      _c("b-spinner", {
                                        staticClass: "align-middle"
                                      }),
                                      _vm._v(" "),
                                      _c("strong", [_vm._v("Загрузка")])
                                    ],
                                    1
                                  )
                                ]
                              },
                              proxy: true
                            },
                            {
                              key: "cell(path)",
                              fn: function(row) {
                                return [
                                  _c(
                                    "b-link",
                                    {
                                      staticStyle: {
                                        color: "#1A9167 !important"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.onDownload(
                                            row.item.id,
                                            row.item.path
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(row.item.path))]
                                  )
                                ]
                              }
                            },
                            {
                              key: "cell(action)",
                              fn: function(row) {
                                return [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        variant: "link",
                                        disabled: _vm.isDisabled
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.onRemove(row)
                                        }
                                      }
                                    },
                                    [
                                      _c("v-icon", {
                                        attrs: {
                                          name: "buttons/trash",
                                          size: 16
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          267335886
                        )
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "page-pagination" },
                    [
                      _c("pagination-footer", {
                        attrs: {
                          "total-rows": _vm.items.length,
                          "per-page": _vm.perPage,
                          "current-page": _vm.currentPage
                        },
                        on: {
                          "update:currentPage": function($event) {
                            _vm.currentPage = $event
                          },
                          "update:current-page": function($event) {
                            _vm.currentPage = $event
                          },
                          "per-page-change": _vm.onPerPageChange
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "footer-list",
                              fn: function() {
                                return [
                                  _vm._v("\n              Всего файлов: "),
                                  _c("b", [_vm._v(_vm._s(_vm.items.length))])
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          false,
                          3045395270
                        )
                      })
                    ],
                    1
                  )
                ]
              : _c(
                  "div",
                  { staticClass: "empty-state-container" },
                  [
                    _c("v-icon", {
                      attrs: { name: "navbar/empty_table", size: 90 }
                    }),
                    _vm._v(" "),
                    _c("h5", [_vm._v("Нет добавленных файлов")])
                  ],
                  1
                )
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "modal_file",
          attrs: {
            id: "modal-file",
            title: "Загрузка файла",
            "modal-class": "custom-modal"
          },
          on: { show: _vm.onResetModal, hidden: _vm.onResetModal },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _c(
                    "div",
                    { staticClass: "w-100 d-flex justify-content-end" },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "custom-btn-secondary mr-2",
                          on: { click: _vm.handleCancel }
                        },
                        [_vm._v("\n          Отменить\n        ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          staticClass: "custom-btn-primary",
                          on: { click: _vm.handleOk }
                        },
                        [_vm._v("\n          Добавить\n        ")]
                      )
                    ],
                    1
                  )
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c(
            "form",
            {
              ref: "form",
              on: {
                submit: function($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  return _vm.handleSubmit.apply(null, arguments)
                }
              }
            },
            [
              _c("b-form-file", {
                attrs: {
                  id: "input_number",
                  size: "sm",
                  placeholder: "Файлы не выбраны",
                  "browse-text": "Выбрать",
                  autocomplete: "off"
                },
                model: {
                  value: _vm.newFile,
                  callback: function($$v) {
                    _vm.newFile = $$v
                  },
                  expression: "newFile"
                }
              })
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-518aa011", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-518aa011","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tasks/TaskFiles.vue
// module id = null
// module chunks = 